<!-- eslint-disable -->
<template>
  <div class="page_box">
    <sb-headline :title="'引流活动'"></sb-headline>
    <my-table ref="list" :data="listData" @page="pageHandler" :listLoading="listLoading">
      <template #header="params">
        <div class="search_box">
          <el-row :gutter="10">
            <el-col :span="6">
              <div class="search_item">
                <div>活动名称：</div>
                <el-input v-model="searchData.activityName"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="search_item">
                <div>活动状态：</div>
                <el-select v-model="searchData.state" placeholder="请选择" clearable>
                  <el-option label="已启用" :value="1"></el-option>
                  <el-option label="已停用" :value="0"></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="margin-top: 10px;">
            <el-col :span="4" :offset="20">
              <el-button @click="pageHandler(params, 1, 'reset')">重置</el-button>
              <el-button @click="pageHandler(params, 1)" type="primary">查询</el-button>
            </el-col>
          </el-row>
        </div>
      </template>
      <template #navBar>
        <div class="table_nav_bar">
          <router-link to="/flowActivity/add">
            <el-button type="primary">新建引流活动</el-button>
          </router-link>
        </div>
      </template>
      <el-table-column label="活动名称" fixed="left" prop="activityName" :min-width="200">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="gotoDetail(scope.row)">{{ scope.row.activityName }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="活动ID" prop="activityCode" :min-width="160"></el-table-column>
      <el-table-column label="浏览PV" prop="pvCount" :min-width="100"></el-table-column>
      <el-table-column label="浏览UV" prop="uvCount" :min-width="100"></el-table-column>
      <el-table-column label="购买人数" prop="purchaseCountUv" :min-width="100"></el-table-column>
      <el-table-column label="购买单数" prop="purchaseCount" :min-width="100"></el-table-column>
      <el-table-column label="状态" prop="orderNum" :min-width="150">
        <template slot-scope="scope">
          <el-switch
            @change="(e)=>changeState(e,scope.row)"
            v-model="scope.row.state"
            active-color="#13ce66"
            inactive-color="#ff4949"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="ctime" :min-width="180"></el-table-column>
      <el-table-column label="操作" fixed="right" prop="" width="120">
        <template slot-scope="scope">
          <el-button class="handle_btn" type="text" size="mini" @click="tableHandle(1, scope.row)">数据</el-button>
          <el-button class="handle_btn" type="text" size="mini" @click="tableHandle(2, scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </my-table>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import { Table } from "@/utils/decorator";
import QRCode from "qrcodejs2";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
    data() {
    //这里存放数据
      return {
        listData: [{},{},{}],
        // 搜索数据
        searchData: {
          activityName: "",     //活动名称
          state: "",            //活动状态
          // userPhone: ""
        },
        searchKey: "customerName", //下拉input所选Key
        listLoading: false, //列表loading
        channelNameList: [                     //渠道名称list
          { channel: '', linkName: '' ,channelMobile: ''}
        ],
        promotionDialogVisible: false,        //推广信息弹窗
        rowActivityCode: "",                  //当前点击的活动code
        activityPopularizeList: [],           //活动推广列表
        url: "",
        rewardDialogVisible: false,
        commissionConfList: [],
        orderItems: [{
          "item":"createTime",
          "type":"desc"
        }],
      };
    },
  filters: {
    stateFilter: function(val) {
      switch (val) {
        case 0:
          return "未开始";
        case 1:
          return "进行中";
        case 2:
          return "已结束";
        default:
          return "";
      }
    },
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    pageHandler(params, num, type) {
      if(type == 'reset'){
        this.resetSearchData();
      }
      this.getActivityList(params, num ? num : params.pageNum, params.pageSize);
    },
    // 表格内操作
    tableHandle(type, row) {
      console.log("type:" + type + " row:" + JSON.stringify(row));
      switch (type) {
        case 1:     //数据
          this.$router.push(`/flowActivity/data?activityCode=${row.activityCode}&activityName=${row.activityName}`);
          break;
        case 2:     //查看
          this.$router.push(`/flowActivity/add?activityCode=${row.activityCode}`);
          break;
        default:
          break;
      }
    },
    // 跳转活动详情
    gotoDetail(row){
      this.$router.push(`/flowActivity/add?activityCode=${row.activityCode}`);
    },

    // 更改状态
    changeState(e,row){
      this.$store.dispatch('management/setFlowActivityState',{
        activityCode: row.activityCode,
        state: e,
      }).then(res => {
        this.$refs.list.init();
      })
    },


    // 重置搜索数据
    resetSearchData(e) {
      this.searchData = {
        activityName: "",     //活动名称
        state: "",            //活动状态
      }
    },



    // 获取活动列表
    getActivityList(params,pageNum,pageSize) {
      this.listLoading = true;
      this.$store.dispatch('management/getFlowActivityList',{
        ...this.searchData,
        pageNum,
        pageSize,
      }).then(res => {
        if(res.code == 0){
          this.listData = res.data.list;
          params.render(res.data.total);
        }
        this.listLoading = false;
      })
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
}
</script>
<style lang="scss" scoped>
  //@import url(); 引入公共css类
  .page_box {
    padding: 0 20px;
    .search_box {
      background: #fff;
      padding: 20px;
      margin-top: 20px;
    }
    .table_nav_bar{
      width: 100%;
      background: #fff;
      padding: 20px 20px 0 20px;
      box-sizing: border-box;
    }
  }
  .handle_btn{
    padding: 0;
  }
  .channel_item{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    >.el-input:nth-child(1){
      width: 260px;
    }
  }
  .channel_item:last-child{
    margin: 0;
  }
  .popularize_list_qrcode{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .qrcode_img_src{
    position: absolute;
    top: -10000%;
    z-index: -10000;
  }
  .search_item{
    display: flex;
    align-items: center;
    >div:first-child{
      flex-shrink: 0;
    }
  }
  ::v-deep .el-table__header thead tr th:first-of-type, .el-table__body tbody tr td:first-of-type{
    padding: 0 !important;
  }
  ::v-deep .el-table__body tbody tr td:first-of-type {
    padding-left: 0px !important;
  }
</style>
